// Derived ids for rows with a natural key, so two devices creating "the same" row offline create
// the same id and sync merges them instead of duplicating (sync-design §Natural keys).
//
// Day: the trip's id with its last 4 bytes replaced by 0xd1 + the date as days since 2000-01-01
// (24 bits). Unique per (trip, date); can't collide with another trip's ids; still a UUIDv7 shape.

const EPOCH_DAYS = daysFromCivil(2000, 1, 1);

/** Days since 1970-01-01 for a proleptic Gregorian date (H. Hinnant). No time zones involved. */
function daysFromCivil(y: number, m: number, d: number): number {
  const yy = m <= 2 ? y - 1 : y;
  const era = Math.floor(yy / 400);
  const yoe = yy - era * 400;
  const doy = Math.floor((153 * (m + (m > 2 ? -3 : 9)) + 2) / 5) + d - 1;
  const doe = yoe * 365 + Math.floor(yoe / 4) - Math.floor(yoe / 100) + doy;
  return era * 146097 + doe - 719468;
}

function daysInMonth(y: number, m: number): number {
  if (m === 2) return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0 ? 29 : 28;
  return [4, 6, 9, 11].includes(m) ? 30 : 31;
}

export function dayId(tripId: string, date: string): string {
  const hex = tripId.toLowerCase().replaceAll('-', '');
  if (!/^[0-9a-f]{32}$/.test(hex)) throw new Error(`invalid trip id: ${tripId}`);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (!m) throw new Error(`invalid date: ${date}`);
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  if (mo < 1 || mo > 12 || d < 1 || d > daysInMonth(y, mo)) throw new Error(`invalid date: ${date}`);
  const n = daysFromCivil(y, mo, d) - EPOCH_DAYS;
  if (n < 0 || n > 0xffffff) throw new Error(`date out of range: ${date}`);
  const out = `${hex.slice(0, 24)}d1${n.toString(16).padStart(6, '0')}`;
  return `${out.slice(0, 8)}-${out.slice(8, 12)}-${out.slice(12, 16)}-${out.slice(16, 20)}-${out.slice(20)}`;
}
